import { render, staticRenderFns } from "./savePoint.vue?vue&type=template&id=398848e5&scoped=true&"
import script from "./savePoint.vue?vue&type=script&lang=js&"
export * from "./savePoint.vue?vue&type=script&lang=js&"
import style0 from "./savePoint.vue?vue&type=style&index=0&id=398848e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398848e5",
  null
  
)

export default component.exports